/**
 * 视频模型 manifest 聚合
 *
 * 接入新视频模型：在 ./<模型>.ts 新增配置文件 → 加入下方数组即可（registry 无需改动）。
 */
import type { VideoModelConfig } from '../../types';
import { kling2_1 } from './kling-v2-1';
import { hailuo02 } from './hailuo-02';
import { wan2_2 } from './wan-v2-2';
import { jimeng3_5Pro } from './jimeng-v3-5-pro';
import { hailuo2_3 } from './hailuo-2-3';
import { kling3_0 } from './kling-v3';
import { kling3_0Omni } from './kling-v3-omni';
import { viduQ3 } from './vidu-q3';
import { seedance2_0 } from './seedance-2-0';
import { wan2_7 } from './wan-v2-7';
import { minimaxH3 } from './minimax-h3';
import { seedance2_5 } from './seedance-2-5';
import { wan3_0 } from './wan-v3-0';
import { wan3_0Prime } from './wan-v3-0-prime';
import { seedance2_0Fast } from './seedance-2-0-fast';

/** 全部视频模型 manifest（统一池，含仅画布模型；画布从此查。顺序不影响查询，仅便于阅读；默认模型按注册顺序作为优先级） */
export const ALL_VIDEO_MODEL_CONFIGS: VideoModelConfig[] = [
  kling2_1,
  hailuo02,
  wan2_2,
  jimeng3_5Pro,
  hailuo2_3,
  kling3_0,
  kling3_0Omni,
  viduQ3,
  seedance2_0,
  wan2_7,
  minimaxH3,
  seedance2_5,
  wan3_0,
  wan3_0Prime,
  seedance2_0Fast,
];

/** feed 展示清单（feedVisible !== false 的模型；向后兼容存量） */
export const VIDEO_MODEL_CONFIGS: VideoModelConfig[] = ALL_VIDEO_MODEL_CONFIGS.filter(m => m.feedVisible !== false);
